<template>
    <qrcode-vue :value="value" :size="size" :level="level"/>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    name: "QrCode",
    props: {
        value: {type: String, default: 'N/A'},
        size: {type: String, default: '150'},
        level: {type: String, default: 'H'},
    },
    components: {
        QrcodeVue,
    },
    data() {
        return {}
    },
}
</script>

<style scoped>

</style>
